import { useEffect, useRef } from 'react';
import MiniHeaderGamesSendMessages from '@lib/components/MiniHeaderGamesSendMessages';	


export function PostMessageListener() {
  const arrowScrollListenerAdded = useRef(false);

  const { sendMessageToGame } = MiniHeaderGamesSendMessages();

  useEffect(() => {
    const allowedDomain = 'iogames.space';
	const validGames = new Map([
		[0, 'mrSword'],
		[1, 'roidz'],
		[2, 'pixelJumper'],
		[3, 'colorMatch'],
		[4, 'rockSkipper'],
	])

    // Mapping numeric values to meaningful strings
    const validTypes = new Map([
      [0, 'mini_game'],
    ]);

    const validActions = new Map([
      [0, 'firstGame'],
      [1, 'retry'],
	  [2, 'gamePlay'],
    ]);

	const validGameStates = new Map([
		[0, 'idle'],
		[1, 'playing'],
		[2, 'stopped'],
	]);

	const disableArrowScroll = (e) => {
		if (['ArrowUp', 'ArrowDown'].includes(e.key)) {
			e.preventDefault();
		}
	};

	const focusMiniGameIframe = () => {
		const miniGameIframe = document.getElementById('iog-mini-header-game');
		sendMessageToGame('RESUME_GAME');
		// const miniGameFullScreenButton = document.querySelector('.full-screen-button');
		if (miniGameIframe) {
			document.body.style.overflow = 'hidden';
			miniGameIframe.focus();
		}
		// if (miniGameFullScreenButton) {
		// 	miniGameFullScreenButton.style.display = 'block';
		// }
	};

	const unfocusMiniGameIframe = () => {
		const miniGameIframe = document.getElementById('iog-mini-header-game');
		sendMessageToGame('PAUSE_GAME');
		// const miniGameFullScreenButton = document.querySelector('.full-screen-button');
		if (miniGameIframe) {
			document.body.style.overflow = '';
		}
		// if (miniGameFullScreenButton) {
		// 	miniGameFullScreenButton.style.display = 'none';
		// }
	};

    const messageHandler = (event) => {
      try {
        // Validate event origin
        const eventURL = new URL(event.origin);
        if (!eventURL.hostname.endsWith(`.${allowedDomain}`) && eventURL.hostname !== allowedDomain) {
        //   console.warn("Blocked message from unauthorized origin:", event.origin);
          return;
        }

		
        const { data } = event;
        if (!data || typeof data !== 'object') return;
		
        // Ensure `type` is a valid number
        if (!validTypes.has(data.type)) return;

        const typeString = validTypes.get(data.type);
		
        const { title, action, state } = data.message || {};
        // Ensure `action` is w1a valid number
        if (!validActions.has(action)) return;

        const actionString = validActions.get(action);
		const gameName = validGames.get(title);
		const gameStates = validGameStates.get(state);

		if (typeString === 'mini_game' && ( actionString === 'firstGame' || actionString === 'retry')) {
			gtag('event', typeString, {
				game_name: gameName,
				play: actionString,
			});
		}

		switch (gameStates) {
			case 'playing':
					focusMiniGameIframe();
				break;

			case 'stopped':
			case 'idle':
				unfocusMiniGameIframe();
				break;
		
			default:
				break;
		}

      } catch (error) {
        console.error("Invalid event or malformed data:", event, error);
      }
    };

    window.addEventListener('message', messageHandler);

    // Cleanup function
    return () => {
      window.removeEventListener('message', messageHandler);
      // Remove arrow scroll disabling if it was set
      if (arrowScrollListenerAdded.current) {
        window.removeEventListener('keydown', disableArrowScroll);
      }
    };
  }, []);

  return null; // No UI needed
}